(function () {
  'use strict';

  if (window.__dbProductCardSizeSheetLoaded) return;
  window.__dbProductCardSizeSheetLoaded = true;

  var activeTrigger = null;
  var activeData = null;
  var selectedVariant = null;
  var sheet = null;
  var scrim = null;
  var addButton = null;
  var sizeContainer = null;

  function createSheet() {
    if (sheet) return;

    scrim = document.createElement('div');
    scrim.className = 'db-size-sheet-scrim';
    scrim.setAttribute('aria-hidden', 'true');

    sheet = document.createElement('section');
    sheet.className = 'db-size-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-labelledby', 'db-size-sheet-title');
    sheet.setAttribute('aria-hidden', 'true');
    sheet.innerHTML = [
      '<div class="db-size-sheet__handle"></div>',
      '<div class="db-size-sheet__header">',
      '<h2 class="db-size-sheet__title" id="db-size-sheet-title">Choose your size</h2>',
      '<button class="db-size-sheet__close" type="button" aria-label="Close size selector">&times;</button>',
      '</div>',
      '<div class="db-size-sheet__product">',
      '<img class="db-size-sheet__image" src="" alt="">',
      '<div><span class="db-size-sheet__vendor"></span><p class="db-size-sheet__name"></p>',
      '<strong class="db-size-sheet__price"></strong><span class="db-size-sheet__price-note"></span></div>',
      '</div>',
      '<div class="db-size-sheet__size-head"><strong>UK size</strong><a class="db-size-sheet__guide" href="/pages/size-guide">Sizing guide</a></div>',
      '<div class="db-size-sheet__sizes"></div>',
      '<button class="db-size-sheet__add" type="button" disabled>Select a size</button>',
      '<p class="db-size-sheet__error" role="alert"></p>',
      '<a class="db-size-sheet__details" href="#">View product details</a>',
      '<div class="db-size-sheet__delivery">Free tracked UK delivery on this pair</div>'
    ].join('');

    document.body.appendChild(scrim);
    document.body.appendChild(sheet);

    addButton = sheet.querySelector('.db-size-sheet__add');
    sizeContainer = sheet.querySelector('.db-size-sheet__sizes');
    sheet.querySelector('.db-size-sheet__close').addEventListener('click', closeSheet);
    scrim.addEventListener('click', closeSheet);
    addButton.addEventListener('click', addSelectedVariant);
  }

  function parseCardData(card) {
    var dataNode = card && card.querySelector('.db-card-size-data');
    if (!dataNode) return null;
    try {
      return JSON.parse(dataNode.getAttribute('data-json') || dataNode.textContent);
    } catch (error) {
      console.error('Double Boxed size selector data error', error);
      return null;
    }
  }

  function openSheet(trigger) {
    createSheet();
    var card = trigger.closest('product-card');
    var data = parseCardData(card);
    if (!data || !Array.isArray(data.variants) || !data.variants.length) {
      window.location.href = trigger.dataset.productUrl || '/collections/all';
      return;
    }

    activeTrigger = trigger;
    activeData = data;
    selectedVariant = null;

    var image = sheet.querySelector('.db-size-sheet__image');
    image.src = data.image || '';
    image.alt = data.title || '';
    sheet.querySelector('.db-size-sheet__vendor').textContent = data.vendor || '';
    sheet.querySelector('.db-size-sheet__name').textContent = data.title || '';
    sheet.querySelector('.db-size-sheet__price').textContent = data.price || '';
    sheet.querySelector('.db-size-sheet__price-note').textContent = data.priceNote || '';
    sheet.querySelector('.db-size-sheet__details').href = data.url || trigger.dataset.productUrl || '#';
    sheet.querySelector('.db-size-sheet__delivery').hidden = !data.freeDelivery;
    sheet.querySelector('.db-size-sheet__error').textContent = '';

    sizeContainer.innerHTML = '';
    data.variants.forEach(function (variant) {
      var option = document.createElement('button');
      option.type = 'button';
      option.className = 'db-size-sheet__size';
      option.textContent = variant.label;
      option.setAttribute('aria-pressed', 'false');
      option.addEventListener('click', function () {
        selectVariant(option, variant);
      });
      sizeContainer.appendChild(option);
    });

    addButton.disabled = true;
    addButton.classList.remove('loading');
    addButton.textContent = 'Select a size';
    document.body.classList.add('db-size-sheet-open');
    scrim.setAttribute('aria-hidden', 'false');
    sheet.setAttribute('aria-hidden', 'false');
    sheet.querySelector('.db-size-sheet__close').focus();
  }

  function selectVariant(option, variant) {
    sizeContainer.querySelectorAll('.db-size-sheet__size').forEach(function (button) {
      button.setAttribute('aria-pressed', button === option ? 'true' : 'false');
    });
    selectedVariant = variant;
    addButton.disabled = false;
    addButton.textContent = 'Add to bag · ' + variant.label;
    if (variant.price) {
      sheet.querySelector('.db-size-sheet__price').textContent = variant.price;
    }
    sheet.querySelector('.db-size-sheet__error').textContent = '';
  }

  function closeSheet() {
    if (!sheet) return;
    document.body.classList.remove('db-size-sheet-open');
    scrim.setAttribute('aria-hidden', 'true');
    sheet.setAttribute('aria-hidden', 'true');
    if (activeTrigger) activeTrigger.focus();
  }

  function sectionInnerHTML(html, selector) {
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var found = parsed.querySelector(selector);
    return found ? found.innerHTML : null;
  }

  function renderCartSections(response) {
    var sections = [
      { id: 'Cart-Drawer', key: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', key: 'cart-bubble', selector: '.thb-item-count' }
    ];

    sections.forEach(function (section) {
      var root = document.getElementById(section.id);
      var html = response.sections && response.sections[section.key];
      if (!root || !html) return;
      var replacement = sectionInnerHTML(html, section.selector);
      if (replacement === null) return;
      var target = root.querySelector(section.selector) || root;
      target.innerHTML = replacement;
    });
  }

  function addSelectedVariant() {
    if (!selectedVariant || addButton.disabled) return;

    addButton.classList.add('loading');
    addButton.setAttribute('aria-disabled', 'true');
    addButton.textContent = 'Adding...';

    var formData = new FormData();
    formData.append('id', selectedVariant.id);
    formData.append('quantity', 1);
    formData.append('sections', 'cart-drawer,cart-bubble');
    formData.append('sections_url', window.location.pathname);

    fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok || payload.status) throw new Error(payload.description || 'Unable to add this size.');
          return payload;
        });
      })
      .then(function (response) {
        renderCartSections(response);
        if (typeof window.dispatchCustomEvent === 'function') {
          window.dispatchCustomEvent('cart:item-added', {
            product: response.items ? response.items[0] : response
          });
        }
        closeSheet();
        var drawer = document.getElementById('Cart-Drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          var cartToggle = document.getElementById('cart-drawer-toggle');
          if (cartToggle) cartToggle.click();
        }
      })
      .catch(function (error) {
        sheet.querySelector('.db-size-sheet__error').textContent = error.message || 'Unable to add this size. Please try again.';
      })
      .finally(function () {
        addButton.classList.remove('loading');
        addButton.removeAttribute('aria-disabled');
        if (selectedVariant) addButton.textContent = 'Add to bag · ' + selectedVariant.label;
      });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-db-size-sheet-trigger]');
    if (!trigger) return;
    event.preventDefault();
    openSheet(trigger);
  });

  document.addEventListener('keydown', function (event) {
    if (!document.body.classList.contains('db-size-sheet-open')) return;
    if (event.key === 'Escape') {
      closeSheet();
      return;
    }
    if (event.key !== 'Tab') return;

    var focusable = Array.prototype.slice.call(sheet.querySelectorAll('button:not([disabled]), a[href]'));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
})();
